var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-notice"},[_c('h1',[_vm._v("Error: ")]),_c('p',[_vm._v("哎呀~您访问的页面不存在哦")])])])
}]

export { render, staticRenderFns }